import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { FulleBaseclientService } from 'src/app/services/apiclient/fulle-baseclient.service';

@Component({
  selector: 'app-fulle-merchant-terms',
  templateUrl: './fulle-merchant-terms.component.html',
})
export class FulleMerchantTermsComponent implements OnInit {
  merchantTerms = '';
  fulleTerms = '';
  loader = true;
  loaderMessage = '';
  id_PoS = '';
  id_name = '';
  domainUser: any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private tools: ToolsService,
    private fulleBaseSlim: FulleBaseclientService,
  ) { }

  ngOnInit() {
    this.domainUser = this.tools.getStor('domainUser');
    if (this.tools.getStor('point_of_sale')) {
      this.id_name = this.tools.getStor('point_of_sale').name_webshop;
      this.loadTerms(this.tools.getStor('point_of_sale').id_menu);
    } else {
      this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);
      return;
    }
  }

  async loadTerms(idPointOfSale: number): Promise<void> {
    try {
      // Chargement des traductions
      const translations = await this.translate.get(['loadergetcond', 'nocond']).toPromise();
      this.loaderMessage = translations['loadergetcond'];

      // Chargement des conditions
      const response = await this.fulleBaseSlim.getBaseSlim('fulle_terms', { id_point_of_sale: idPointOfSale });

      this.merchantTerms = response.data?.conditionPos || translations['nocond'];
      this.fulleTerms = response.data?.conditionFulle || translations['nocond'];

    } catch (error) {
      const nocond = await this.translate.get('nocond').toPromise();
      this.merchantTerms = nocond;
      this.fulleTerms = nocond;
    } finally {
      this.loader = false;
    }
  }
}